import { Tabs } from '@bfe/moly';
import { Modal } from '@web3/base-components';
import cls from 'classnames';
import { useFm } from '@web3/base-hooks';
import dayjs from 'dayjs';
import BigNumber from 'bignumber.js';
import { formatAmount } from '@/utils';
import { TimeInfo, DexTradeRules } from '@/types/project';
import { useScreenType } from '@/hooks/media';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  onClose: () => void;
}

export enum TabKey {
  WALLET = 'wallet',
  SPOT = 'spot',
}

const bbSolConfig = [
  {
    amount: 1,
    value: 24,
  },
  {
    amount: 2,
    value: 48,
  },
  {
    amount: 5,
    value: 96,
  },
  {
    amount: 10,
    value: 200,
  },
];

const dexproConfig = [
  {
    amount: 500,
    value: 50,
  },
  {
    amount: '2,000',
    value: 200,
  },
  {
    amount: '5,000',
    value: 500,
  },
  {
    amount: '20,000',
    value: '2,500',
  },
  {
    amount: '50,000',
    value: '7,000',
  },
  {
    amount: '150,000',
    value: '15,000',
  },
  {
    amount: '500,000',
    value: '35,000',
  },
  {
    amount: '1,000,000',
    value: '50,000',
  },
];

export const LearnModal = (props: Props) => {
  const { show, onClose } = props;
  const fm = useFm();
  // 当前在第几周
  // const weedendIndex = projectTimeList?.findIndex((item) => {
  //   const currentTime = dayjs.utc();

  //   const isStart = currentTime.isAfter(dayjs(item.start));
  //   const isNotEnd = currentTime.isBefore(dayjs(item.end));

  //   return isStart && isNotEnd;
  // });
  const { isMobile } = useScreenType();

  const FooterBtn = (
    <button className={styles.footer} onClick={onClose}>
      {fm('i_know')}
    </button>
  );

  const WalletContent = (
    <>
      <div className={styles.content}>
        <div className={styles.levelHead}>
          <div className={styles.tradeVolumnHead}>{fm('task')}</div>
          <div className={styles.scoreHead}>{fm('qty')}</div>
          <div
            className={styles.randomHead}
          >{`${fm('score')} (${fm('daily')})`}</div>
        </div>
        <div className={styles.levelContent}>
          <div className={styles.tradeVolumnValue}>{fm('bbSolHolding')}</div>
          <div className={styles.levelContentDetail}>
            {bbSolConfig?.map((item, index) => {
              return (
                <div
                  className={cls(styles.levelRow, {
                    [styles.levelRowSpitial]: index % 2 === 1,
                  })}
                  key={index}
                >
                  <div
                    className={styles.scoreValue}
                  >{`${item.amount} bbSOL`}</div>
                  <div className={styles.randomValue}>{`${item.value}`}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.levelContent}>
          <div className={styles.tradeVolumnValue}>{fm('dexProTrading')}</div>
          <div className={styles.levelContentDetail}>
            {dexproConfig?.map((item, index) => {
              return (
                <div
                  className={cls(styles.levelRow, {
                    [styles.levelRowSpitial]: index % 2 === 1,
                  })}
                  key={index}
                >
                  <div className={styles.scoreValue}>{`$${item.amount}`}</div>
                  <div className={styles.randomValue}>{`${item.value}`}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.pointDesc}>{fm('earnVotingPointsMethod')}</div>
      <div className={styles.pointDesc}>{fm('excludeZeroFeePairVolume')}</div>
      <div className={styles.pointDesc}>
        {fm('updateHourlyVotingAndBbsolData')}
      </div>
      <div className={styles.pointDesc}>{fm('votingPointsLimit')}</div>
      <div className={styles.extraDesc}>
        <div className={styles.pointDesc}>
          {fm('dailyVotingPointsLimit', {
            amount: `50,200`,
          })}
        </div>
        <div className={styles.pointDesc}>
          {fm('dailyVotingPointsLimit2', {
            amount: `50,200`,
          })}
        </div>
        <div className={styles.pointDesc}>
          {fm('participantTotalDailyVotingPointsLimit', {
            amount: `100,400`,
          })}
        </div>
      </div>
    </>
  );

  const SpotContent = (
    <>
      <div className={styles.content}>
        <div className={styles.levelHead}>
          <div className={styles.tradeVolumnHead}>{fm('task')}</div>
          <div className={styles.scoreHead}>{fm('qty')}</div>
          <div
            className={styles.randomHead}
          >{`${fm('score')} (${fm('daily')})`}</div>
        </div>
        <div className={styles.levelContent}>
          <div className={styles.tradeVolumnValue}>{fm('bbSolHolding')}</div>
          <div className={styles.levelContentDetail}>
            {bbSolConfig?.map((item, index) => {
              return (
                <div
                  className={cls(styles.levelRow, {
                    [styles.levelRowSpitial]: index % 2 === 1,
                  })}
                  key={index}
                >
                  <div
                    className={styles.scoreValue}
                  >{`${item.amount} bbSOL`}</div>
                  <div className={styles.randomValue}>{`${item.value}`}</div>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styles.levelContent}>
          <div className={styles.tradeVolumnValue}>{fm('spotTrading')}</div>
          <div className={styles.levelContentDetail}>
            {dexproConfig?.map((item, index) => {
              return (
                <div
                  className={cls(styles.levelRow, {
                    [styles.levelRowSpitial]: index % 2 === 1,
                  })}
                  key={index}
                >
                  <div className={styles.scoreValue}>{`$${item.amount}`}</div>
                  <div className={styles.randomValue}>{`${item.value}`}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className={styles.pointDesc}>{fm('earnVotingPointsMethod')}</div>
      <div className={styles.pointDesc}>{fm('excludeZeroFeePairVolume')}</div>
      <div className={styles.pointDesc}>
        {fm('updateHourlyVotingAndBbsolData')}
      </div>
      <div className={styles.pointDesc}>{fm('votingPointsLimit')}</div>
      <div className={styles.extraDesc}>
        <div className={styles.pointDesc}>
          {fm('dailyVotingPointsLimit', {
            amount: `50,200`,
          })}
        </div>
        <div className={styles.pointDesc}>
          {fm('dailyVotingPointsLimit2', {
            amount: `50,200`,
          })}
        </div>
        <div className={styles.pointDesc}>
          {fm('participantTotalDailyVotingPointsLimit', {
            amount: `100,400`,
          })}
        </div>
      </div>
    </>
  );

  return (
    <Modal
      open={show}
      className={styles.modalWrapper}
      contextWrapper={styles.modalContextWrapper}
      onCancel={onClose}
      modal={false}
      size="medium"
      cancelText={false}
      title={fm('getTradingPoints')}
      isMobile={isMobile}
      direction={!isMobile ? 'center' : 'bottom'}
      footer={FooterBtn}
      footerWrapper={styles.footerWrapper}
    >
      <div className={styles.container}>
        <Tabs
          className="w-full"
          size="s"
          tabType="buttonBg"
          isEqualDivided
          tabBarGutter={4}
          tabBarWithContentGutter={16}
          items={[
            {
              key: TabKey.WALLET,
              label: fm('bybitWeb3Wallet'),
              children: WalletContent,
            },
            {
              key: TabKey.SPOT,
              label: fm('bybitMainAccount'),
              children: SpotContent,
            },
          ]}
          defaultActiveKey={TabKey.WALLET}
        />
      </div>
    </Modal>
  );
};
